import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withShortcuts } from '../../../containers/Shortcuts'
import { toggleNewThread } from '../../../store/actions/discuss'
import { newThreadSelector } from '../../../store/selectors/discussSelectors'

const DiscussControlsContainer = compose(
  connect(
    state => ({
      newThread: newThreadSelector(state)
    }),
    { toggleNewThread }
  ),
  withShortcuts('DISCUSS', props => (action, event) => {
    switch (action) {
      case 'NEW_THREAD':
        props.toggleNewThread()
        event.preventDefault()
        break
      default:
    }
  }),
  withTranslation()
)

export default DiscussControlsContainer
